<div class="w-[40%] absolute top-[45px] right-[0.5%] bg-[#f4f4f4] border border-black z-[99] p-5">
  <div class="flex justify-between">
    <h2 class="text-primary text-2xl">Activities Queue
    </h2>
    <button class="rounded-none shadow-sm p-1" (click)="closeModal()">
      <mat-icon class="text-black">close</mat-icon>
    </button>
  </div>
  <ul class="list-none p-0 mb-2">
    @if (activities?.length === 0) {
      <li class="bg-white border border-gray-300 rounded-none p-2">
        <span class="text-gray-500">No activities found.</span>
      </li>
    } @else {
      @for (activity of activities; track activity.id) {
        <li class="bg-white border border-gray-300 rounded-none p-2 grid grid-cols-1 md:grid-cols-6 text-sm">
          <div class="md:col-span-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            <span class="truncate" [matTooltip]="activity.id" matTooltipPosition="above">{{ activity.id }}</span>
            <span class="text-gray-400 text-center">{{ activity.date | date:'MMM dd' }}</span>
            <span>{{ activity.type | titlecase }}</span>
          </div>
          <div class="flex items-center justify-between md:col-span-2 group">
            <div class="flex items-center">
              @if (activity.status === 'complete') {
                <mat-icon class="mr-1 text-icon-success">check_circle</mat-icon>
              } @else if (activity.status === 'failed' || activity.status === 'canceled') {
                <mat-icon class="mr-1" svgIcon="exclamation-square-fill"></mat-icon>
              } @else {
                <mat-icon class="mr-1 animate-spin" svgIcon="arrow-repeat"></mat-icon>
              }
              @if (activity.status === 'complete' || activity.status === 'failed' || activity.status === 'canceled') {
                <a [routerLink]="['/activity-queue', activity.id]" class="text-utility-link underline">
                  {{ activity.status | titlecase }}
                </a>
              } @else {
                {{ activity.status | titlecase }}
              }
            </div>
            <div class="flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              @if (activity.canPause) {
                <mat-icon class="text-black cursor-pointer" (click)="pause(activity)" matTooltip="Pause">pause</mat-icon>
              }
              @if (activity.canResume) {
                <mat-icon class="text-black cursor-pointer" (click)="resume(activity)" matTooltip="Resume">play_arrow</mat-icon>
              }
              @if (activity.canCancel) {
                <mat-icon class="text-black cursor-pointer" (click)="cancel(activity)" matTooltip="Cancel">cancel</mat-icon>
              }
              <mat-icon class="text-black cursor-pointer" (click)="delete(activity)" matTooltip="Delete">close</mat-icon>
            </div>
          </div>
        </li>
        <li>
          <mat-progress-bar mode="determinate" [value]="activity.completion"></mat-progress-bar>

        </li>
      }
    }
  </ul>
  <p class="text-[12px] flex justify-end text-primary underline">
    <a routerLink="/activity-queue" (click)="closeModal()">View Activities Queue</a>
  </p>
</div>
